<template>
  <div :class="$style['certificate-page']">
    <div :class="$style['page-line']"></div>
    <div :class="$style['certificate-header']">创新实践</div>
    <div :class="[$style['mobile-certificate'],{[$style['certificate']]:index === 1}]" v-for="(item, index) in certsList" :key="item.id">
      <img :src="item.sortImg" :class="$style['cer-header']"/>
      <p :class="$style['cer-title']">{{item.title}}</p>
      <img :src="item.certImg"  :class="$style['cer-image']" />
      <div :class="$style['intro-list']">
        <div :class="$style['cer-content']" v-for="i in item.intro" :key="i">
          <div :class="$style['content-icon']"><div></div></div>
          <div :class="$style['content-item']">{{i}}</div>
        </div>
      </div>
       <div :class="$style['cer-btn']" v-if="index === 1" @click="handleRoute">了解详情</div>
    </div>

  </div>
</template>

<script>
import { getCertsList } from './data'

export default {
  name: '',
  components: {
  },
  props: {
  // visible: VueTypes.bool.def(false)
  },
  data () {
    return {
      certsList: getCertsList(true)
    }
  },
  created () {
  },
  mounted () {
  },
  watch: {
  },
  methods: {
    handleRoute () {
      window.location.href = 'https://ict.geekbang.com/'
    }
  }
}
</script>
<style lang='scss' module>
.certificate-page {
  background: #F9F9F9;
  text-align: center;
  padding-bottom: 50px;
  & .page-line {
    height: 1px;
    margin: 0 auto;
    background: linear-gradient(270deg, #FFFFFF 0%, #EAEAEA 16%, #DCDCDC 83%, #FFFFFF 100%);
  }

}
.certificate-header {
  margin: 50px auto 0;
  font-size: 20px;
  font-weight: 500;
  color: #404040;
}
.mobile-certificate {
  width: 100%;
  padding: 30px 0 0;
  text-align: center;
  & .cer-header {
    width: 28px;
    height: 22px;
    margin: 0 auto;
  }
  & .cer-title {
    width: 280px;
    margin: 0 auto;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #404040;
  }

  & .cer-image {
    width: 225px; height: 162px;
    margin: 20px auto;

  }
  & .cer-content {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0 30px;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    & .content-icon {
      position: relative;
      min-width: 22px;
      min-height: 22px;
      background: #D1E6FF;
      border-radius: 50%;
      margin-top: 5px;

      & div {
        position: absolute; left: 7px; top: 7px;
        min-width: 8px;
        min-height: 8px;
        background: #5286FF;
        border-radius: 50%;
      }
    }
    & .content-item {
      margin-left: 12px;
      line-height: 28px;
      text-align: left;
      font-size: 14px;
      font-weight: 300;
      color: #404040;
    }

  }
  &.certificate {
    .cer-header {
      width: 37px;
      height: 24px;
      margin-bottom: -6px;
    }
  }
  & .cer-btn {
    width: 180px; height: 36px;
    line-height: 36px;
    margin: 30px auto 0;
    // padding-bottom: 50px;
    background: linear-gradient(90deg, #2E7DFF 0%, #71A7FF 100%);
    border-radius: 21px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
  }

}

</style>
